import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function GitHubCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Build the redirect URL with all query params
    const params = new URLSearchParams();

    searchParams.forEach((value, key) => {
      params.set(key, value);
    });

    // Redirect to GitHub settings page with the callback params
    params.set('tab', 'github');
    navigate(`/settings?${params.toString()}`, { replace: true });
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
        <p className="mt-4 text-gray-600 dark:text-gray-300">Completing GitHub connection...</p>
      </div>
    </div>
  );
}
